import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators';
import { ACTION_FETCH } from './const';
import { Items, Organizations, OrganizationsResponse, Providers } from '../types';
import { Dictionary } from 'vuex';

const asNumber = (value: number | string): number => value && (typeof value === 'string' ? parseInt(value, 10) : value) || 0;

const UPDATE_ITEMS = 'updateItems';
const UPDATE_COUNT = 'updateCount';

const storeModule = (providers: Providers) => {
  const { $api } = providers;

  @Module({
    namespaced: true,
    stateFactory: true,
  })
  class PageOrganizationsStore extends VuexModule {
    // State
    items: Items = [];
    count: number = 0;

    // Mutations
    @Mutation
    [UPDATE_ITEMS](items: Organizations) {
      this.items = items;
    }

    @Mutation
    [UPDATE_COUNT](count: number) {
      this.count = count;
    }

    // Actions
    @Action
    async [ACTION_FETCH](params: Dictionary<any>): Promise<void> {
      try {
        const { data: { data, filtered } } = await $api.get<OrganizationsResponse>('organizationlist/get', { params });
        this.context.commit(UPDATE_COUNT, asNumber(filtered));
        this.context.commit(UPDATE_ITEMS, data.map((organization) => {
          const result = {
            ...organization,
            code: organization.code || '',
            logo: organization.logo || '',
          };
          return result;
        }));
      } catch (e) {
        // Обрабатываем ошибку
        this.context.commit(UPDATE_ITEMS, false);
      }
    }
  }

  return PageOrganizationsStore;
}

export default storeModule;



// WEBPACK FOOTER //
// ./src/pages/organizations/map/store.ts